module.exports = __webpack_public_path__ + "img/logo.015a785e.jpg";